import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { Edge, EdgeChange } from '@xyflow/react';

export function FN_GRAPH_UPDATE__edge_remove__by_change(change: EdgeChange<Edge>, graph: DTO_GRAPH__instance) {
  if (change.type !== 'remove') return false;

  let id = change.id;

  let { edges } = graph;
  edges = edges.filter(edge => edge.edge_id == id);

  graph.edges__delete(edges);

  return true;
}
